import {
  Notifications as NotificationsIcon,
} from '../icons';
import React, { useState, useCallback, useEffect, useRef } from 'react';
import {
  IconButton,
  Badge,
  Tooltip
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import NotificationDropdown from './NotificationDropdown';
import notificationService from '../../services/notificationService';
import { useNotification } from '../../contexts/NotificationContext';

const ORDER_NOTIFICATION_TYPES = ['order_created', 'order_updated'];

const isToday = (dateString) => {
  const date = new Date(dateString);
  const today = new Date();
  return (
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate()
  );
};

const NotificationBell = () => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);
  const { unreadCount: contextUnreadCount } = useNotification();
  const prevContextCount = useRef(contextUnreadCount);

  const open = Boolean(anchorEl);

  const fetchUnreadCount = useCallback(async () => {
    try {
      const response = await notificationService.getNotifications({
        page: 1,
        limit: 50,
        unread_only: true,
      });

      const formattedNotifications = notificationService.formatNotifications(
        response.notifications
      );

      const count = formattedNotifications.filter(
        (n) =>
          ORDER_NOTIFICATION_TYPES.includes(n.notification_type) &&
          isToday(n.created_at) &&
          !n.is_read
      ).length;

      setUnreadCount(count);
    } catch (error) {
      console.error('Error fetching notification count:', error);
    }
  }, []);

  useEffect(() => {
    fetchUnreadCount();
  }, [fetchUnreadCount]);

  useEffect(() => {
    if (contextUnreadCount !== prevContextCount.current) {
      prevContextCount.current = contextUnreadCount;
      if (!open) {
        fetchUnreadCount();
      }
    }
  }, [contextUnreadCount, open, fetchUnreadCount]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNotificationRead = useCallback(() => {}, []);

  const handleUnreadCountChange = useCallback((newCount) => {
    setUnreadCount(newCount);
  }, []);

  return (
    <>
      <Tooltip title="Pending Orders Today">
        <IconButton
          onClick={handleClick}
          size="large"
          sx={{
            color: theme.palette.mode === 'dark' ? 'white' : 'inherit',
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          }}
        >
          <Badge
            badgeContent={unreadCount}
            color="error"
            max={99}
            sx={{
              '& .MuiBadge-badge': {
                fontSize: '0.75rem',
                minWidth: '18px',
                height: '18px',
              },
            }}
          >
            <NotificationsIcon />
          </Badge>
        </IconButton>
      </Tooltip>

      <NotificationDropdown
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onNotificationRead={handleNotificationRead}
        onUnreadCountChange={handleUnreadCountChange}
      />
    </>
  );
};

export default NotificationBell;
